export default "__VITE_ASSET__bxRqtmPc__"